import { UnifiedFeedback } from '../types/unifiedFeedback';

export function getFeedbackExternalUrl(feedback: Pick<
  UnifiedFeedback,
  'platform' | 'url' | 'short_code' | 'video_web_url' | 'author'
>): string | null {
  if (feedback.url) {
    return feedback.url;
  }

  if (feedback.platform === 'instagram' && feedback.short_code) {
    return `https://www.instagram.com/p/${feedback.short_code}`;
  }

  if (feedback.platform === 'tiktok' && feedback.video_web_url) {
    return feedback.video_web_url;
  }

  if (feedback.platform === 'instagram' && feedback.author) {
    return `https://www.instagram.com/${feedback.author.replace(/^@/, '')}`;
  }

  return null;
}

export function getFeedbackExternalLabel(feedback: Pick<UnifiedFeedback, 'platform' | 'account_name'>): string {
  switch (feedback.platform) {
    case 'instagram':
      return feedback.account_name ? `View on ${feedback.account_name}` : 'View on Instagram';
    case 'google':
      return feedback.account_name || 'View on Google Maps';
    case 'tiktok':
      return 'View on TikTok';
    case 'facebook':
      return 'View on Facebook';
    case 'gcc':
      return 'View GCC details';
    case 'dm':
      return 'View in app';
    default:
      return 'View original';
  }
}
